<div id="how-to-sell-container">
  <div id="content-container">
    <h1 class="card-header">
      {{ 'HOW_TO_SELL_YOUR_ESTATE' | translate | uppercase}}
    </h1>
    <div id="how-to-sell-content" *ngIf="ls.howToArticles">
      <div class="article-container" *ngFor="let howTo of ls.howToArticles; index as i">
        <div class='article-content-container'>
          <img class="how-to-sell-image" [ngStyle]="{'margin-top': i===0 ? '20px' : '65px'}"
               [src]="'assets/images/how_to_'+(i+1)+'.png'" alt="how-to-sell-img">
          <div class="text">
            <h3 class="subtitle" *ngIf="i>0">{{howTo.header | translatedb}}</h3>
            <div class="how-to-sell-text" [innerHTML]="howTo.article | translatedb"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
